import React, { useState } from "react";
import { PageHero, DraftNotice } from "@/components/common/SectionHeading";
import { submitForeignInquiry } from "@/lib/lnlApi";
import { toast } from "sonner";

export default function ForeignInquiry() {
    const [f, setF] = useState({ full_name:"", nationality:"", country_of_residence:"", email:"", messaging_number:"", preferred_program:"", highest_education:"", intended_intake:"", question:"", consent:false });
    const [ref, setRef] = useState(null);
    async function submit(e) {
        e.preventDefault();
        if (!f.consent) return toast.error("Please give privacy consent.");
        try { const r = await submitForeignInquiry(f); setRef(r.reference); toast.success("Foreign inquiry received"); }
        catch { toast.error("Could not send inquiry."); }
    }
    return (
        <div data-testid="foreign-inquiry-page">
            <PageHero eyebrow="Foreign student inquiry" title="Foreign student inquiry" description="A separate inquiry path routed to the LNL Foreign Affairs Office." breadcrumbs={[{label:"Home",to:"/"},{label:"Admissions",to:"/admissions"},{label:"Foreign Inquiry"}]} />
            <section className="py-10 bg-white">
                <div className="lnl-container max-w-2xl">
                    <DraftNotice tone="warn">Foreign-student requirements and procedures will be confirmed by the LNL Foreign Affairs Office.</DraftNotice>
                    {!ref ? (
                        <form onSubmit={submit} className="lnl-card p-6 mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="foreign-form">
                            {[
                                ["full_name","Full name"],["nationality","Nationality"],["country_of_residence","Country of residence"],
                                ["email","Email"],["messaging_number","Mobile / messaging number"],["preferred_program","Preferred program"],
                                ["highest_education","Highest completed education level"],["intended_intake","Intended intake"],
                            ].map(([k,l]) => (
                                <div key={k}>
                                    <label className="text-xs text-lnl-gray font-heading font-semibold">{l}</label>
                                    <input value={f[k]||""} onChange={(e)=>setF({...f,[k]:e.target.value})} className="mt-1 w-full rounded-md border border-lnl-border px-3 py-2.5" data-testid={`fi-${k}`} required={["full_name","nationality","country_of_residence","email","messaging_number"].includes(k)} type={k==="email"?"email":"text"} />
                                </div>
                            ))}
                            <div className="sm:col-span-2">
                                <label className="text-xs text-lnl-gray font-heading font-semibold">Main question</label>
                                <textarea value={f.question} onChange={(e)=>setF({...f,question:e.target.value})} className="mt-1 w-full rounded-md border border-lnl-border px-3 py-2.5" rows={4} data-testid="fi-question" />
                            </div>
                            <label className="sm:col-span-2 flex items-start gap-2 text-xs text-lnl-gray">
                                <input type="checkbox" checked={f.consent} onChange={(e)=>setF({...f,consent:e.target.checked})} data-testid="fi-consent" />
                                I consent to be contacted by the LNL Foreign Affairs Office.
                            </label>
                            <div className="sm:col-span-2"><button className="lnl-btn-primary" data-testid="fi-submit">Send inquiry</button></div>
                        </form>
                    ) : (
                        <div className="lnl-card p-6 mt-4"><div className="font-heading text-xl font-bold">Received</div><div className="mt-1 text-sm">Reference: <b>{ref}</b>. The Foreign Affairs Office will follow up.</div></div>
                    )}
                </div>
            </section>
        </div>
    );
}
